
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import { User } from '../webservices/models';

@Component({
    name: 'CurrentUser',
})
export default class CurrentUser extends Vue {
    private mainStore = mainStore.context(this.$store);

    private center: number[] = [0, 0];
    private zoom: number = 5;
    private rotation: number = 0;

    private get centerCoordinate(): number[] | null {
        return this.currentUser
            ? [
                  Number(this.currentUser.location.coordinates.longitude),
                  Number(this.currentUser.location.coordinates.latitude),
              ]
            : null;
    }
    private get currentUser(): User | null {
        return this.mainStore.state.currentUser;
    }
    private get favUsers(): User[] {
        return this.mainStore.state.favUsers;
    }

    private addFavUser(user: User): void {
        this.mainStore.actions.updateFavUsers(user);
    }
}
